<template>
    <div :class="prefixCls" class="px-16px">
        <el-form class="mt-12px" ref="ruleFormRef" :rules="rules" :model="state" label-position="top">
            <el-form-item prop="display_name" class="relative" :label="t('register.name')">
                <el-input v-model.trim="state.display_name" :placeholder="t('register.namePlaceholder')" autocomplete="off" maxlength="50" />
            </el-form-item>
            <el-form-item prop="mobile" :label="t('register.phone')" class="register-phone">
                <MobileInput v-model:mobile="state.mobile" v-model:region="state.region" class="mobile-input-box h-32"></MobileInput>
                <!-- <el-input
                    type="number"
                    v-model="state.mobile"
                    :placeholder="t('register.phonePlacholder')"
                    autocomplete="off"
                    :rows="1"
                    oninput="this.value=this.value.slice(0,20)"
                    onwheel="event.preventDefault()"
                >
                    <template #prepend>
                        <el-select
                            class="phone-select !w-105px"
                            popper-class="common-popper"
                            placeholder="+86"
                            v-model="state.region"
                            :suffix-icon="SuffixIcon"
                        >
                            <template #label="{ label, value }">
                                <span class="!w-30 mr-8" :class="[`fi fi-${label.toLowerCase()}`]"></span>
                                <span>{{ value }}</span>
                            </template>
                            <el-option v-for="(item, index) in country" :key="item.phoneCode" :label="item.countryCode" :value="item.phoneCode">
                                <div class="flex items-center">
                                    <span class="!w-30" :class="[`fi fi-${item.countryCode.toLowerCase()}`]"></span>
                                    <span class="mx-8">{{ index <= 2 ? item.chineseName : item.englishName }}</span>
                                    <span>{{ item.phoneCode }}</span>
                                </div>
                            </el-option>
                        </el-select>
                    </template>
                </el-input> -->
            </el-form-item>
            <el-form-item prop="user_company" :label="t('register.company')">
                <el-input v-model.trim="state.user_company" maxlength="50" :placeholder="t('register.companyPlaceholder')"></el-input>
                <!-- <el-select popper-class="common-popper" :placeholder="t('register.companyPlaceholder')" v-model="state.user_company">
                    <el-option v-for="(item, index) in state.companyOpts" :key="item.label" :label="item.label" :value="item.label"></el-option>
                </el-select> -->
            </el-form-item>
            <el-form-item prop="institution_type" :label="t('register.institutionType')">
                <el-select
                    popper-class="common-popper"
                    :placeholder="t('register.institutionTypePlaceholder')"
                    v-model="state.institution_type"
                    clearable
                >
                    <el-option
                        v-for="(item, index) in state.institutionTypeOpts"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="position" :label="t('register.position')">
                <el-input v-model.trim="state.position" maxlength="50" :placeholder="t('register.positionPlaceholder')"></el-input>
                <!-- <el-select popper-class="common-popper" :placeholder="t('register.positionPlaceholder')" v-model="state.position">
                    <el-option v-for="(item, index) in state.positionOpts" :key="item.label" :label="item.label" :value="item.label"></el-option>
                </el-select> -->
            </el-form-item>
            <el-form-item prop="academic_field" :label="t('register.academicField')">
                <el-input v-model.trim="state.academic_field" maxlength="50" :placeholder="t('register.academicFieldPlaceholder')"></el-input>
                <!-- <el-select popper-class="common-popper" :placeholder="t('register.academicFieldPlaceholder')" v-model="state.academic_field">
                    <el-option v-for="(item, index) in state.academicFieldOpts" :key="item.label" :label="item.label" :value="item.label"></el-option>
                </el-select> -->
            </el-form-item>
            <el-form-item prop="user_email" :label="t('register.email')">
                <el-input
                    v-model.trim="state.user_email"
                    :placeholder="t('register.emailPlacholder')"
                    autocomplete="off"
                    maxlength="50"
                />
            </el-form-item>
            <!-- <el-form-item prop="user_company" :label="t('register.company')">
                <el-input
                    type="textarea"
                    v-model="state.user_company"
                    :placeholder="t('register.companyPlaceholder')"
                    autocomplete="off"
                    maxlength="50"
                    show-word-limit
                    :rows="1"
                />
            </el-form-item>
            <el-form-item prop="user_department" :label="t('register.deparment')">
                <el-input
                    type="textarea"
                    v-model="state.user_department"
                    :placeholder="t('register.departmentPlaceholder')"
                    autocomplete="off"
                    maxlength="50"
                    show-word-limit
                    :rows="1"
                />
            </el-form-item> -->
            <!-- <div class="mb-20px relative">
                <div class="mr-8x absolute top--6PX">
                    <el-checkbox v-model="checked" />
                </div>
                <span class="ml-24px">{{ t('register.tip1') }}</span>
                <span @click="openContent(DialogContentType.SERVICE_AGREEMENT)" class="text-[var(--a-link-color)] cursor-pointer">
                    {{ t('common.agreement1') }}
                </span>
                ,
                <span @click="openContent(DialogContentType.PRIVACY)" class="text-[var(--a-link-color)] cursor-pointer">
                    {{ t('common.agreement2') }}
                </span>
                <span>{{ t('common.and') }}</span>
                <span @click="openContent(DialogContentType.PRIVACY)" class="text-[var(--a-link-color)] cursor-pointer">
                    {{ t('common.agreement3') }}
                </span>
                {{ t('register.tip3') }}
            </div> -->
            <div class="flex-center w-full mb-24px">
                <el-button @click="cancel" class="mr-24px !h-32px !w-96px">{{ t('register.cancel') }}</el-button>
                <div
                    class="common-btn-1 w-96 h-32 !flex items-center justify-center hover:op-70"
                    :class="{ disabled: !checked }"
                    @click="registerUser"
                >
                    <span>{{ t('register.register') }}</span>
                </div>
            </div>
        </el-form>
    </div>
    <DialogInformation :type="type" @close="() => (type = undefined)" />
</template>
<script setup lang="ts">
import { register } from '@/apis/login';
import { useDesign } from '@/hooks/web/useDesign';
import { overseasMobile } from '@/config';
import { DialogContentType } from '@/views/ServiceAgreement/config';
import { FormInstance, FormRules } from 'element-plus';
import DialogInformation from '@/views/ServiceAgreement/components/DialogInformation.vue';
import { Message } from '@/utils/message';
import { useI18n } from 'vue-i18n';
import MobileInput from '@/components/MobileInput.vue';

const { t } = useI18n();

const checked = ref(false);
const { getPrefixCls } = useDesign();
const prefixCls = getPrefixCls('register-form');
const { push } = useRouter();

const emit = defineEmits(['afterRegister', 'cancel']);
let intlTelInput = ref();
const type = ref();
const openContent = (contentType: DialogContentType) => {
    type.value = contentType;
};
const ruleFormRef = ref<FormInstance>();
const state = reactive({
    mobile: '',
    display_name: '',
    user_email: '',
    region: '+86',
    user_company: '',
    user_department: '',
    institution_type: '',
    position: '',
    academic_field: '',
    companyOpts: [{ label: '清华大学' }, { label: 'Harvard University' }, { label: '国家图书馆' }],
    institutionTypeOpts: [{ label: '高校' }, { label: '科研机构' }, { label: '企业' }, { label: '政府' }, { label: '医院' }, { label: '其他' }],
    positionOpts: [{ label: '教授' }, { label: '研究员' }, { label: '博士后' }, { label: '博士生' }, { label: '工程师' }],
    academicFieldOpts: [{ label: '人工智能' }, { label: '分子生物学' }, { label: '物理学' }, { label: '社会学' }],
});
const rules = computed(() =>
    reactive<FormRules>({
        mobile: [
            { required: true, message: t('register.phonePlacholder'), trigger: 'change' },
            { pattern: state.region === '+86' ? /^\d{11}$/ : /^\d{1,}$/, message: t('register.errorTip1'), trigger: 'change' },
        ],
        user_email: [{ pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: t('register.errorTip2'), trigger: 'change' }],
        display_name: [{ required: true, message: t('register.namePlaceholder'), trigger: 'change' }],
        user_company: [{ required: true, message: t('register.companyPlaceholder'), trigger: 'change' }],
    })
);

function handleMobileBlur(e: any) {
    state.mobile = e.target.value.replace(/\s/g, '');
}

const registerUser = async () => {
    // if (!checked.value) {
    //     Message.error(t('register.registerWarning'));
    //     return false;
    // }
    await ruleFormRef.value?.validate(async (valid, fields) => {
        if (valid) {
            let { mobile, display_name, user_email, user_company, user_department, region, institution_type, position, academic_field } = state;
            let params = {
                mobile,
                display_name,
                user_email,
                user_company,
                user_department,
                region,
                institution_type,
                position,
                academic_field,
            };
            try {
                await register(params);
                Message.success(t('register.successTip1'), 1000);
                emit('afterRegister');
            } catch (e: any) {
                const code = e.response?.data?.detail?.code;
                if (code === 409) {
                    // push(LOGIN_PATH)
                }
            }
        } else {
            console.log('error submit!', fields);
        }
    });
};

const cancel = () => {
    emit('cancel');
};
</script>
<style lang="scss" scoped>
:deep(.phone-select .el-select__wrapper) {
    padding: 0 5px !important;
}
:deep(.el-form) {
    .el-form-item__label {
        font-size: 14px !important;
    }
    .el-form-item__content {
        font-size: 14px !important;
        input,
        textarea {
            font-size: 14px !important;
        }
    }
}
$prefix-cls: $self-namespace + '-register-form';
.#{$prefix-cls} {
    :deep(.el-form-item) {
        margin-bottom: 24px;
        &.is-error .el-input__wrapper {
            box-shadow: 0 0 0 0.0625rem var(--el-color-danger) inset !important;
        }
        .el-form-item__content {
            background-color: #fff;
            border-radius: 8px;
        }
    }
}
:deep(.mobile-input-box) {
    .el-select {
        width: 120px;
    }
}
</style>
